export default __webpack_public_path__ + "static/media/onboardImg4.15008e46.jpg";